import { Store } from 'api/types/store';
import * as Yup from 'yup';
import _pick from 'lodash/pick';
import { StoreBaseFormProps } from './StoreBaseForm';

interface AddressRequirements {
  requireCity: boolean;
  requireState: boolean;
}

// Each address field is required only once the store already has it. Quick Setup collects neither,
// and the API accepts both blank, so demanding one would block an unrelated edit such as a rename.
export const getValidationStoreSchema = ({ requireCity, requireState }: AddressRequirements) =>
  Yup.object().shape({
    storeName: Yup.string().required('A name is required'),
    country: Yup.string().required('Country is required'),
    postalCode: Yup.string().required('Postal code is required'),
    city: requireCity ? Yup.string().required('Rental city is required') : Yup.string(),
    state: requireState
      ? Yup.string().when('country', {
          is: 'US',
          then: Yup.string().required('State is required'),
        })
      : Yup.string(),
    description: Yup.string().required('Description is required'),
  });

export const getInitialValuesFromStore = (store: Store): StoreBaseFormProps['initialValues'] => {
  const values = _pick(store, [
    'storeName',
    'country',
    'postalCode',
    'city',
    'state',
    'description',
    'image',
    'street1',
  ]);

  // Quick Setup stores have no address yet, and the schema rejects null before its required checks
  return {
    ...values,
    postalCode: values.postalCode ?? '',
    city: values.city ?? '',
    state: values.state ?? '',
    street1: values.street1 ?? '',
  };
};
